import { Service as service } from '@/configs/enums/basics';
/**
 * 内部服务接口地址
 */
const innerServiceApiUrl = import.meta.env.VITE_API_URL;
const mockUrl = 'https://apifoxmock.com';

const proxyConfig = {
  // 默认服务
  default: {
    base: {
      base: service.基础服务,
      url: `${innerServiceApiUrl}/`,
    },
    file: {
      base: service.文件服务,
      url: `${innerServiceApiUrl}/`,
    },
    auth: {
      base: service.认证服务,
      url: `${innerServiceApiUrl}/`,
    },
    study: {
      base: service.学习服务,
      url: `${innerServiceApiUrl}/`,
    },
  },
  // 如果是其他系统的服务
  mock: {
    teaching: {
      url: `${mockUrl}/m1/4845600-0-7d15fdbc`,
    },
  },
};
export default proxyConfig;
